import { getSettings } from '../settings';

const isImageContainer = (node) => {
  const settings = getSettings();
  return node.matches(settings.imageContainer);
};

export default isImageContainer;
